import React, { useEffect, useRef, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { CheckBox, DateBox, NumberBox } from "devextreme-react";
import { VEN_Reservas_DisponibilidadPorArticulo } from "../../Componentes/Compuestos/Complejos/Operaciones/VEN_Reservas_DisponibilidadPorArticulo";
import LV_EEX_Clientes from "../../Componentes/Compuestos/Complejos/Clientes/LV_EEX_Clientes";
import ComboAbmArtArticulos_Reservables from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos_Reservables";
import { function_VEN_Reservas_Cabecera_Insertar, function_VEN_Reservas_Generar_JSON } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import SignatureCanvas from "react-signature-canvas";

export const VEN_Reservas_ModificacionCreacion = () => {

  let { IdReserva, Terminal } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [fecha, setFecha] = useState(new Date());
  const [idCliente, setIdCliente] = useState(0);
  const [importeTotal, setImporteTotal] = useState(0);
  const [cantidad, setCantidad] = useState(1);
  const [dataArticulos, setDataArticulos] = useState([])
  const [dataDetalles, setDataDetalles] = useState([])
  const [codigoArticulo, setCodigoArticulo] = useState("")
  const [puedeGuardar, setPuedeGuardar] = useState(false)
  const [esEvento, setEsEvento] = useState(false)
  const [fechaReadOnly, setFechaReadOnly] = useState(false)
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [modalFirmaVisible, setModalFirmaVisible] = useState(false);
  const sigCanvas = useRef(null);
  const [firmaOK, setFirmaOK] = useState(false);
  const [sinFirma, setSinFirma] = useState(false);
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [firmaBase64, setFirmaBase64] = useState("");
  const linkTerminos = "https://neftis.com.ar/Terminos/" + localStorage.getItem("CodigoCompania") + "/Terminos.htm"

  const onClickEliminarActividad = (identificador) => {
    setDataArticulos((dataArticulos) => dataArticulos.filter((articulo) => articulo.Identificador !== identificador));
    setDataDetalles((dataDetalles) => dataDetalles.filter((detalle) => detalle.Identificador !== identificador));
  };  

  const onValueChangedCodigoArticulo = async (e) => {
    setCodigoArticulo(e.value)
  }

  const onValueChangedCantidad = async (e) => {
    setCantidad(e.value)
  }

  const onValueChangedFecha = async (e) => {
    setFecha(e.value)
  }

  const onClickAgregar = () => {
    try {
      if (cantidad < 1) {
        alert("La cantidad debe ser mayor a cero.");
        return;
      }

      if (!codigoArticulo || codigoArticulo === "") {
        alert("Es necesario seleccionar una actividad.");
        return;
      }

      const Agregar = async () => {
        setLoading(true)

        const dataArticulosNew = {
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoArticulo: codigoArticulo,
          Cantidad: cantidad,
          Identificador: Date.now()  // <-- ID único basado en timestamp
        };

        setDataArticulos(dataArticulos => [...dataArticulos, dataArticulosNew]);

        setPuedeGuardar(true)
        setFechaReadOnly(true)
      }

      Agregar();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false)
    }
  };

  const onClickGuardar = () => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      if (idCliente < 1) {
        alert("El Cliente no ha sido seleccionado.");
        return;
      }

      if (!dataArticulos) {
        alert("Al menos una actividad debe ser seleccionada.");
        return;
      }

      if (dataDetalles.length !== dataArticulos.length) {
        alert("Falta completar el Horario de alguna de las actividades.");
        return;
      }

      const Guardar = async () => {
        setLoading(true)

        const jsonFinal = await function_VEN_Reservas_Generar_JSON(idCliente, importeTotal, 1,
          fecha, esEvento, dataDetalles, [])

        jsonFinal.FirmaResponsable = firmaBase64;

        const IdReserva = await function_VEN_Reservas_Cabecera_Insertar(jsonFinal)

        alert('Se ha creado la Reserva Nº ' + IdReserva.data.codigoGenerado)
        navigate(`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}/${IdReserva.data.codigoGenerado}`);
      }

      Guardar();

    } catch (error) {
      alert(error);
    } finally {
      setLoading(false)
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  useEffect(() => {
    if (Terminal && Terminal > 0) {
      if (Terminal != localStorage.getItem("Terminal")) {
        localStorage.setItem("Terminal", Terminal);
        window.location.reload()
      }
    }

    Terminal = localStorage.getItem("Terminal");

    if (localStorage.getItem("CodigoCompania") === "307") {
      setSinFirma(true)
    }

    while (Terminal === "0" || !Terminal) {
      const nuevoTerminal = prompt("Por favor, ingrese el número de terminal:");

      if (nuevoTerminal && nuevoTerminal !== "0") {
        localStorage.setItem("Terminal", nuevoTerminal);
        Terminal = nuevoTerminal;
        window.location.reload()
      } else {
        alert("Debe ingresar un número de terminal válido para continuar.");
      }
    }
  }, []);

  useEffect(() => {
    setImporteTotal(dataDetalles.reduce((total, detalle) => total + (detalle.Importe * detalle.Cantidad), 0))
  }, [dataDetalles]);

  return (
    <PaginaCarga
      Titulo={"RESERVAS - TERMINAL: " + localStorage.getItem("Terminal") + " - CÓD. PERSONA: " + localStorage.getItem("IdPersona")}
    >
      <LV_EEX_Clientes
        setIdParticipante={setIdCliente} />

      <div className="LV-GroupBox-div LV-FlexContainer"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center' }}
      >
        Fecha:
        <DateBox width={140} displayFormat="dd/MM/yyyy"
          value={fecha}
          style={{ marginLeft: '5px', marginRight: '20px' }}
          readOnly={fechaReadOnly}
          onValueChanged={onValueChangedFecha} />

        <CheckBox
          text="Evento"
          value={esEvento}
          onValueChanged={(e) => setEsEvento(e.value)}
          style={{ marginRight: '20px' }} // Espacio entre CheckBox y el botón
        />

        Actividad:
        <ComboAbmArtArticulos_Reservables
          onValueChanged={onValueChangedCodigoArticulo}
          ancho={"500"}
          style={{ marginLeft: '5px', marginRight: '20px' }} />

        Cantidad:
        <NumberBox style={{ marginLeft: '5px', marginRight: '40px', width: '50px' }} value={cantidad} onValueChanged={onValueChangedCantidad} />

        <LVButtonAccion
          Texto="AGREGAR"
          Ancho={200}
          onClick={onClickAgregar}
        />
      </div>

      {dataArticulos.map((articulo, index) => (
        <VEN_Reservas_DisponibilidadPorArticulo
          key={articulo.Identificador}
          Identificador={articulo.Identificador}
          Fecha={fecha}
          CodigoArticulo={articulo.CodigoArticulo}
          Cantidad={cantidad}
          dataDetalles={dataDetalles}
          SetDataDetalles={setDataDetalles}
          onEliminar={() => onClickEliminarActividad(articulo.Identificador)}
        />
      ))}

      <div className="LV-FlexContainer"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}
      >
        IMPORTE TOTAL:
        <NumberBox text="IMPORTE TOTAL: " value={importeTotal}
          readOnly={true}
          format={{
            type: 'currency',
            precision: 0, // Número de decimales
          }} />
        <LVButtonAccion
          Texto={
            cierreEnProceso
              ? "Guardando..."
              : sinFirma
                ? "GUARDAR"
                : !firmaOK
                  ? "Firmá para continuar"
                  : "GUARDAR"
          }
          Disabled={cierreEnProceso || (!firmaOK && !sinFirma)}
          Ancho={200}
          onClick={onClickGuardar}
          visible={puedeGuardar}
        />

        <LVButtonAccion
          Texto="FIRMAR"
          Ancho={200}
          onClick={() => setModalFirmaVisible(true)}
        />

        {firmaOK && (
          <div style={{ fontWeight: 'bold', color: 'green' }}>FIRMADO ✅</div>
        )}
      </div>

      {modalFirmaVisible && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{ backgroundColor: 'white', padding: 20, borderRadius: 10, width: 900, textAlign: 'center' }}>
            <h3>Firma del Responsable</h3>
            <p>Firmá a continuación y aceptá los términos como responsable de todos los menores.</p>

            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{ width: 450, height: 150, className: 'sigCanvas', style: { border: "1px solid black" } }}
            />

            <CheckBox
              text="Acepto los términos y condiciones como responsable de todos los menores"
              value={aceptaTerminos}
              onValueChanged={(e) => setAceptaTerminos(e.value)}
              style={{ marginTop: 10, marginBottom: 10 }}
            />

            <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
              <LVButtonAccion Texto="LIMPIAR" onClick={() => sigCanvas.current.clear()} />
              <LVButtonAccion
                Texto="GUARDAR FIRMA"
                Disabled={!aceptaTerminos || sigCanvas.current?.isEmpty()}
                onClick={() => {
                  if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
                    const firma = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
                    console.log(firma)
                    setFirmaBase64(firma);
                    setFirmaOK(true);
                    setModalFirmaVisible(false);
                  } else {
                    alert("La firma está vacía o no cargó correctamente.");
                  }
                }}
              />
              <LVButtonAccion Texto="CANCELAR" onClick={() => setModalFirmaVisible(false)} />
            </div>
            <div style={{ margin: '10px', padding: '5px' }}>
              <iframe
                src={linkTerminos}
                width="100%"
                height="500px"
                title="Términos y Condiciones"
              />
            </div>
          </div>
        </div>
      )}
    </PaginaCarga>
  );
}
